import { useTheme } from '@emotion/react'
import React from 'react'
import { P, SectionHeading,SectionSubWrapper } from '../../../../Styles/style'
import Menu from "../../../../Components/TopMenu/index"
import whitelogo from "../../../../../assets/images/whitelogo.png"
const Header = (props) => {
  const theme = useTheme()
    return (

    <div>
        <SectionSubWrapper p="1rem 0 8rem" bgcolor={theme.bgSecondary}>
            <Menu color={theme.textSecondary} logo={whitelogo} />
            <SectionHeading align="center" color={theme.textSecondary} p="70px 0 10px" data-aos="zoom-in"
          data-aos-easing="ease-in"
          data-aos-delay="300"
          data-aos-offset="0"
          data-aos-duration="1000">{props.heading}</SectionHeading>
            <P align="center" color={theme.textSecondary} p="0" m="0" data-aos="fade-up"
          data-aos-easing="ease-in"
          data-aos-delay="300"
          data-aos-offset="0"
          data-aos-duration="1000">{props.para}</P>
        </SectionSubWrapper>
    </div>
  )
}

export default Header